import React from 'react';
import { Field, reduxForm } from "redux-form";
import classNames from 'classnames';

const renderSearch = ({ id, disabled, input, placeholder,
    type, cb, meta: { touched, error }, }) => {
    const invalid = touched && error;
    return (
        <div className="w-100">
            <input
                id={id}
                {...input}
                placeholder={placeholder}
                type={type}
                disabled={disabled}
                className={classNames("form-control", { "is-invalid": invalid, })}
                onChange={(data) => {
                    input.onChange(data);
                    if (cb) cb();
                }}
                style={{ "paddingRight": "40px" }}
            />
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

const Form = (props) => (
    <div className={`ui icon input ${props.className}`}>
        <Field
            name='search'
            type="text"
            placeholder = "Search by name, email"
            component={renderSearch}
            cb={props.onSubmit}
            className="form-control"
        />
        <i aria-hidden="true" className="search icon"></i>
    </div>
)

const Search = reduxForm({
    form: 'searchPointsClients',
    destroyOnUnmount: false,
})(Form);

export default Search;